module.exports = __webpack_public_path__ + "static/media/2-min.jpg.fa1aff90.webp";